module.exports = __webpack_public_path__ + "static/media/prop-1@2x.f470499b.png";